import React, { useEffect, useState } from "react";


const NomineeOptOutSdk = () => {
  const [token, setToken] = useState("");
  const [sdkData, setSdkData] = useState(null);

  const [clientId, SetClientId] = useState("");
  const [kyCId, SetKyCId] = useState("");
  const [requestId, setRequestID] = useState("");


  const fetchToken = () => {
    // Replace 'YOUR_API_ENDPOINT' with the actual API endpoint to fetch the token
    const apiUrl =
      "https://ainxt.nomineeoptout.uat.ainxtkyc.com/generatetoken";



    const myHeaders = new Headers();
    myHeaders.append("x-api-key", "KEICbyyzfnPmpxefSyyDf7Px5XJfol5bJBnklbj0");
    myHeaders.append("authorizationToken", "nYB3odfPm6oFR3v2");
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "clientid": clientId,
      "kycid": kyCId,
      "requestid": requestId
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch("https://ainxt.nomineeoptout.prod.ainxtkyc.com/generatetoken", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setToken(data.token); // Assuming the response contains the 'token' field
        console.log(data)
      })
      .catch((error) => {
        console.error("Error fetching token:", error);
      });
  };


  const handleSDKData = (data) => {
    setSdkData(data);
  };

  // window.AinxtSDK.Initialize(token, handleSDKData);
  function myFunction() {
    let client_id = clientId; // Default user_type // "fresh" or "rejected" or "dormant"
    let kyc_id = kyCId; // Default project_name // "diy" or  "partner"
    let request_id = requestId; // Default request_id 
    window.AinxtSDK.Initialize(token, handleSDKData, "0", client_id, kyc_id, request_id);
  }

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://djb8n07maz7m7.cloudfront.net/nominee_opt_out_prod.js";
    script.async = true;

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="text-center">
      <h1 className="text-4xl font-bold mb-8">Nominee opt out SDK Test</h1>


      <input
        type="text"
        placeholder="Enter client ID"
        value={clientId}
        onChange={(e) => SetClientId(e.target.value)}
        className="form-control"
        style={{
          padding: "10px",
          width: "300px",
          margin: "10px auto",
          display: "block",
          borderRadius: "5px",
        }}
      />
      <input
        type="text"
        placeholder="Enter kyc ID "
        value={kyCId}
        onChange={(e) => SetKyCId(e.target.value)}
        className="form-control"
        style={{
          padding: "10px",
          width: "300px",
          margin: "10px auto",
          display: "block",
          borderRadius: "5px",
        }}
      />

{/* 
      <input
        type="text"
        placeholder="Enter Request ID"
        value={requestId}
        onChange={(e) => setRequestID(e.target.value)}
        className="form-control"
        style={{
          padding: "10px",
          width: "300px",
          margin: "10px auto",
          display: "block",
          borderRadius: "5px",
        }}
      /> */}


      <button
        className="bg-blue-500 hover:bg-blue-700 text-dark font-bold py-2 px-4 rounded"
        onClick={fetchToken}
      >
        Get Token
      </button>
      {token && (
        <button
          className="mt-4 bg-green-500 hover:bg-green-700 text-dark font-bold py-2 px-4 rounded"
          onClick={myFunction}
        >
          Initialize AinxtSDK
        </button>
      )}
      {sdkData && (
        <div className="mt-4">
          <h2 className="text-xl font-bold mb-2">Data from SDK:</h2>
          <pre className="whitespace-pre-wrap font-bold">{JSON.stringify(sdkData, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default NomineeOptOutSdk;